module.exports = __webpack_public_path__ + "media/images/guideline/F_02-c72f0764340d8d0664a33886bd29668f.jpg";